function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
export var Alert = /*#__PURE__*/ function () {
    function Alert(options) {
        var _this$options;
        _classCallCheck(this, Alert);
        this.options = options;
        _defineProperty(this, "buttons", void 0);
        _defineProperty(this, "wrap", void 0);
        if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.question) {
            this.buttons = "\n\t\t\t\t<button type=\"button\" class=\"vv-alert-btn vv-alert-confirm\">".concat(Alert.button_labels.confirm, "</button>\n\t\t\t\t<button type=\"button\" class=\"vv-alert-btn vv-alert-decline\">").concat(Alert.button_labels.decline, "</button>\n\t\t\t");
        }
        else {
            this.buttons = "\n\t\t\t\t<button type=\"button\" class=\"vv-alert-btn vv-alert-ok btn-vv-secondary\">".concat(Alert.button_labels.ok, "</button>\n\t\t\t");
        }
        if ((options === null || options === void 0 ? void 0 : options.instant) != false) {
            this.render();
        }
        return this;
    }
    _createClass(Alert, [{
            key: "build",
            value: function build() {
                var _this$options3;
                var _this$options2 = this.options, title = _this$options2.title, content = _this$options2.content, type = _this$options2.type;
                var wrap = document.createElement('div');
                wrap.classList.add('vv-alert-wrap');
                var tpl_head = function tpl_head(title, type) {
                    return "<div class=\"vv-alert-header\">\n\t\t\t".concat(type ? "<div class=\"vv-alert-icon\"><i class=\"".concat(Alert.type_icons[type], " fa-3x\"></i></div>") : '', "\n\t\t\t").concat(title ? "<h4>".concat(title, "</h4>") : '', "\n\t\t</div>");
                };
                var tpl_body = function tpl_body(content) {
                    return "<div class=\"vv-alert-body\">".concat(content, "</div>");
                };
                var tpl = "\n\t\t\t<div class=\"vv-alert-content vv-alert--".concat((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.type ? this.options.type : 'confirm', "\">\n\t\t\t\t<div class=\"vv-alert\">\n\t\t\t\t\t").concat(title || type ? tpl_head(title, type) : '', "\n\t\t\t\t\t").concat(content ? tpl_body(content) : '', "\n\t\t\t\t\t<div class=\"vv-alert-footer\">\n\t\t\t\t\t\t").concat(this.buttons, "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");
                wrap.innerHTML = tpl;
                return wrap;
            }
        }, {
            key: "render",
            value: function render() {
                var _this = this, _this$wrap$querySelec;
                var domEl = this.build();
                this.wrap = domEl;
                this.wrap.addEventListener('click', function (ev) {
                    var btn = ev.target.closest('.vv-alert-btn');
                    if (!btn)
                        return;
                    if (btn.classList.contains('vv-alert-ok')) {
                        var _this$options4;
                        if ((_this$options4 = _this.options) !== null && _this$options4 !== void 0 && _this$options4.url) {
                            window.location.href = _this.options.url;
                        }
                        else {
                            _this.destroy();
                        }
                    }
                });
                document.body.appendChild(this.wrap);
                this.buttons && ((_this$wrap$querySelec = this.wrap.querySelector('button')) === null || _this$wrap$querySelec === void 0 ? void 0 : _this$wrap$querySelec.focus());
            }
        }, {
            key: "destroy",
            value: function destroy() {
                this.wrap && this.wrap.remove();
                this.wrap = undefined;
            }
        }]);
    return Alert;
}();
_defineProperty(Alert, "button_labels", {
    'ok': 'Gerai',
    'confirm': 'Taip',
    'decline': 'Ne',
    'cancel': 'Atšaukti'
});
_defineProperty(Alert, "type_icons", {
    'success': 'fas fa-check-circle text-success',
    'warning': 'fas fa-exclamation-triangle text-warning',
    'danger': 'fas fa-times-circle text-danger'
});
